import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import MuiTextField from '@mui/material/TextField'
import { useWhiteLabelingContext } from '@app/context/WhiteLabelingContext'

const StyledTextField = styled(MuiTextField)`
  label {
    text-transform: lowercase;
    ${(props) =>
      props.display === 'standard' &&
      css`
        text-transform: capitalize;
      `}
    ${(props) =>
      props.display === 'noChange' &&
      css`
        text-transform: none;
      `}
  }
  input {
    background: ${(props) => props.theme.palette.background.paper};
    border-radius: ${(props) => props.theme.shape.borderRadius}px;
  }
`

const TextField = ({
  value = undefined,
  children,
  size = 'medium',
  helperText = '',
  whiteLabeled = false,
  ...props
}) => {
  const { planColorPrimary } = useWhiteLabelingContext()
  const inputLabelProps = {}
  if (value) {
    inputLabelProps.shrink = value.length > 0
  }
  return (
    <StyledTextField
      variant='outlined'
      bgcolor='background.paper'
      margin='normal'
      fullWidth
      size={size}
      value={value}
      helperText={helperText}
      error={!!helperText}
      InputLabelProps={inputLabelProps}
      {...props}
      sx={{
        ...(props.sx || {}),
        ...(whiteLabeled
          ? {
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: planColorPrimary,
                },
                '&:hover fieldset': {
                  borderColor: planColorPrimary,
                },
                '&.Mui-focused fieldset': {
                  borderColor: planColorPrimary,
                },
              },
              '& .MuiInputLabel-root': {
                color: planColorPrimary,
              },
              '& .MuiInputLabel-root.Mui-focused': {
                color: planColorPrimary,
              },
            }
          : {}),
      }}
    />
  )
}

TextField.propTypes = {
  children: PropTypes.node,
  helperText: PropTypes.string,
  size: PropTypes.string,
  value: PropTypes.string,
}

export default TextField
